import { Table } from 'antd';
import styled from 'styled-components';

export const StyledTable = styled(Table)`
  .ant-table-tbody > tr.ant-table-row-selected > td {
    background: transparent;
  }
`;
